import React, { useState, useEffect } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import { useLocation, useNavigate } from "react-router-dom";
import SideBarItems from "./Sidebar";
import { FaBarsStaggered } from "react-icons/fa6";
import { useAppContext } from "../Context/AppProvider";
import Swal from "sweetalert2";

function Layout({ children, setDarkMode, darkMode }) {
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isLarge, setIsLarge] = useState(true);
  const {logoutAdmin} = useAppContext()
  // Detect admin routes using a switch-style check
  const adminRoutes = [ "/admin/questions", "/admin/docs", "/admin/settings" ,"/admin/chat-history",'admin/lessons'];
  const isAdminPage = adminRoutes.some((route) => location.pathname.includes(route));

  useEffect(() => {
    // Automatically hide sidebar on small screens
    const handleResize = () => {
      setSidebarOpen(window.innerWidth >= 768); // md breakpoint
    };

    handleResize(); // Initial call
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const navigate = useNavigate()
  return (
    <div className="h-screen flex flex-col">
      {!isAdminPage && (
        <Header
          darkMode={darkMode}
          setDarkMode={setDarkMode}
          toggleSidebar={() => setSidebarOpen(!sidebarOpen)}
        />
      )}

      {isAdminPage ? (
        <div className="main-layout">
          <div
            className={`sidebar-main ${isLarge ? "sidebar-large" : "sidebar-small"}`}
          >
            <div className="logo-main">{isLarge ? "Admin Panel" : "Panel"}</div>
            <SideBarItems isLarge={isLarge} />
          </div>
          <div className="right-main">
            <div className="navbar-main">
              <div>
                <FaBarsStaggered
                  className="cursor"
                  onClick={() => setIsLarge(!isLarge)}
                />
              </div>
             <div
  onClick={async () => {
    const result = await Swal.fire({
      title: 'Are you sure you want to logout?',
      text: 'You will be redirected to the login page.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, logout!',
      cancelButtonText: 'Cancel',
      customClass: {
        confirmButton: 'swal2-confirm-button',
        cancelButton: 'swal2-cancel-button'
      }
    });

    if (result.isConfirmed) {
      localStorage.clear();
      await logoutAdmin();
      navigate('/admin/login');
    }
  }}
  className="right-items"
>
  <div role="button" className="cursor-pointer">
    Logout
  </div>
</div>

            </div>
            <div className="main-content">{children}</div>
          </div>
        </div>
      ) : (
        <div className="flex flex-1 overflow-hidden">{children}</div>
      )}
    </div>
  );
}

export default Layout;
